// extracted by mini-css-extract-plugin
export default {"overlay":"Spinnerabsolute_overlay__ilP7+","spinner":"Spinnerabsolute_spinner__pz2Na","s7":"Spinnerabsolute_s7__eZ5vQ"};